import { render, staticRenderFns } from "./WebhookFilters.vue?vue&type=template&id=8b64d630&"
import script from "./WebhookFilters.vue?vue&type=script&lang=js&"
export * from "./WebhookFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports